import RpcService from 'helpers/RpcService';
import RpcTypes from 'constants/rpcTypes';
import { GraphData, ChartFilters } from 'types/Analytics';

const createChart = (payload): Promise<GraphData> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Analytics_CreateChart,
        payload,
      },
    ],
  });
};

const getUserCharts = (
  payload?
): Promise<Array<{ biChartId: string; order: number }>> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Analytics_GetUserCharts,
        payload,
      },
    ],
  });
};

const getChart = ({ id }: { id: string }): Promise<any> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Analytics_GetChart,
        payload: { id },
      },
    ],
  });
};

const deleteChart = ({ id }: { id: string }) => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Analytics_DeleteChart,
        payload: { id },
      },
    ],
  });
};

const moveChart = (payload: { from: string; to: string }) => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Analytics_MoveChart,
        payload,
      },
    ],
  });
};

const getChartFilters = (payload: {
  id: string;
}): Promise<{ data: ChartFilters }> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Analytics_GetChartFilters,
        payload,
      },
    ],
  });
};

const editChart = (payload): Promise<GraphData> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Analytics_EditChart,
        payload,
      },
    ],
  });
};

export {
  getChart,
  createChart,
  getUserCharts,
  deleteChart,
  moveChart,
  getChartFilters,
  editChart,
};
